import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';

  .EmailAlertsPage {
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    // Match the background used by the embedded Dolphin subscription page.
    background: #eceff5;

    iframe {
      display: block;
      width: 100%;
      // 外部页不发 iframeResize（实测）、跨域测不到内容高；与 Trade Hub 同一定案：
      // 恒 100vh 内部滚动——表单态里层滚动，订阅后的确认卡一屏居中无大空白
      height: 100vh;
      border: none;
      background: #eceff5;
      border-radius: 5px;
    }

    @include respond-to(sm) {
      // Keep the embedded confirmation view from touching the mobile viewport edges.
      padding: 0 16px;

      iframe {
        // The page header sits above the iframe, so leave room for it and center the
        // external page's viewport in the remaining mobile viewport.
        height: calc(100vh - 80px);
        min-height: 560px;
      }
    }
  }
`;

export { staticStyles };
